export default "__VITE_ASSET__nNa2fYs0__"